import React from 'react';
import clsx from 'clsx';

function FloatingInput({
  label,
  name,
  type = 'text',
  value,
  onChange,
  required = false,
  error,
  className,
  ...rest
}) {
  const inputId = name;
  const errorId = `${name}-error`;

  return (
    <div className={clsx('relative', className)}>
      <input
        id={inputId}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        required={required}
        placeholder=" "
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={error ? errorId : undefined}
        className={clsx(
          'peer w-full bg-surface-50 border rounded-xl text-surface-900 pt-5 pb-2 px-4',
          'focus:ring-2 focus:bg-white focus:outline-none transition-all duration-200',
          'text-body placeholder-transparent',
          error
            ? 'border-error-500 focus:ring-error-500/20 focus:border-error-500'
            : 'border-surface-200 focus:ring-primary-500/20 focus:border-primary-500'
        )}
        {...rest}
      />
      <label
        htmlFor={inputId}
        className={clsx(
          'absolute left-4 transition-all duration-200 pointer-events-none select-none',
          'peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-body peer-placeholder-shown:text-surface-400',
          'peer-focus:top-2 peer-focus:-translate-y-0 peer-focus:text-caption peer-focus:text-primary-600',
          'top-2 -translate-y-0 text-caption',
          error ? 'text-error-500 peer-focus:text-error-500' : 'text-surface-500'
        )}
      >
        {label}
        {required && <span className="text-error-500 ml-0.5">*</span>}
      </label>

      {error && (
        <div id={errorId} className="flex items-center gap-1.5 mt-1.5 px-1" role="alert">
          <svg
            className="w-3.5 h-3.5 text-error-500 flex-shrink-0"
            fill="currentColor"
            viewBox="0 0 20 20"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
          <span className="text-caption text-error-600">{error}</span>
        </div>
      )}
    </div>
  );
}

export default FloatingInput;
